/**
 * Suspense fallback shown while a lazy route chunk loads.
 *
 * ponytail: the other exports this file used to carry (ComponentLoader,
 * FullScreenLoader, Card/Table/Chart/ListSkeleton) had zero callers anywhere
 * in src/ — dead flexibility for a loading spinner nobody wired up. Add one
 * back the day a screen actually needs a different fallback shape.
 */

import { Loader2 } from 'lucide-react';

export function PageLoader() {
  return (
    <div className="flex min-h-[60vh] items-center justify-center">
      <div className="text-center">
        <Loader2 className="mx-auto mb-4 h-10 w-10 animate-spin text-ink" />
        <p className="text-muted">Memuat halaman...</p>
      </div>
    </div>
  );
}

export default PageLoader;
